// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { Google as GoogleIcon } from '@zocdoc-frontend-common/assets-icons';

import BaseSocialLoginButtonTransparent from './BaseSocialLoginButtonTransparent';

export default function GoogleLoginButtonTransparent({
    message = 'Continue with Google',
    ...props
}) {
    return (
        <BaseSocialLoginButtonTransparent
            icon={StyledGoogleIcon}
            message={message}
            {...props}
        />
    );
}

const StyledGoogleIcon = styled(GoogleIcon)`
    font-size: 24px;
`;
